import React, { useEffect, useState } from "react";
import styled from "styled-components";
import IconSAT from '../../assets/images/icon-sat.svg'
import IconComplete from '../../assets/images/icon-complete.svg'
import ButtonComponent from "../button";
import InputComponent from "../evaluation-form-components/input";
import DatePickerComponent from "../evaluation-form-components/date_picker";

const Container = styled.div`
    width: 100%;
    /* height: 100%; */
`;

const Banner = styled.div`
    width: calc(100% - 16px);
    /* height: 331px; */
    background: linear-gradient(153.06deg, rgba(246, 210, 133, 0.3) -0.31%, rgba(187, 240, 243, 0.3) 99.69%);
    padding: 12px 8px;
    position: relative;
    display: flex;
    flex-direction: column;

    .icon-header-box {
        /* width: 114px; */
        .icon-header {
            width: 156px;
        }
    }

    .label {
        color: #25368D;
        font-size: 24px;
        font-weight: 500;
        line-height: 35.88px;
        text-align: center;
    }

    .icon-sat-box {
        position: absolute;
        top: 8px;
        right: 8px;

        .icon-sat {
            width: 48px;
        }
    }
`;

const Body = styled.div`
    width: calc(100% - 48px);
    height: calc(100% - 319px);
    padding: 16px 24px 24px 24px;
    display: flex;
    flex-direction: column;

    .description {
        color: #2A2A2A;
        font-size: 14px;
        font-weight: 300;
        line-height: 20.93px;
        text-align: left;
        margin-bottom: 8px;
    }
    .title {
        color: #25368D;
        font-size: 24px;
        font-weight: 500;
        line-height: 35.88px;
        text-align: left;
        margin-bottom: 12px;
    }
    .button-footer {        
        /* margin-top: 48px; */
        gap: 8px;
    }
`;


function EvaluationFormProfile({
    back,
    evaluationFormData,
    anonymous,
    onBack,
    onClickSave,
}) {
    const [isInvalidValue, setIsInvalidValue] = useState({
        mobile_number: false
    });
    const [detail, setDetail] = useState({
        firstname: null,
        lastname: null,
        mobile_number: null,
        birthdate: null,
        province: null,
    })
    const [haveHistory, setHaveHistory] = useState(false)

    useEffect(() => {
        if (back) {
            onBack && onBack("profile")
        }
    }, [back])

    useEffect(() => {
        if (anonymous) {
            setHaveHistory(true)
        } else {
            if (evaluationFormData?.evaluator_profile) {
                const evaluator_profile = evaluationFormData?.evaluator_profile;
                setDetail({
                    firstname: evaluator_profile.firstname,
                    lastname: evaluator_profile.lastname,
                    mobile_number: evaluator_profile.mobile_number,
                    birthdate: evaluator_profile.birthdate,
                    province: evaluator_profile.province,
                })
                if (evaluator_profile.mobile_number &&
                    evaluator_profile.birthdate &&
                    evaluator_profile.province
                ) {
                    // setHaveHistory(true)
                }
            }
        }
    }, [evaluationFormData, anonymous])

    function onCheckFormat(key, value) {
        let check = true;
        if (!value) return check;
        let regex;
        if (key === "mobile_number") {
            regex = /^(0[689]{1})+([0-9]{8})+$/;
            const test = regex.test(value)
            check = test;
        }
        return check;
    }

    function handleChange(key, value) {
        let _detail = {
            ...detail
        }
        _detail[key] = value || null;
        setDetail(_detail);
        let _isInvalidValue = { ...isInvalidValue };
        for (let item of Object.keys(_isInvalidValue)) {
            _isInvalidValue[item] = false;
        }
        setIsInvalidValue(_isInvalidValue);
    }
    function handleClickSave() {
        if (!onCheckFormat("mobile_number", detail.mobile_number)) {
            setIsInvalidValue((prev) => { return { ...prev, mobile_number: true } })
            return;
        }
        onClickSave && onClickSave("edit", detail);
    }
    function handleClickCancel() {
        onClickSave && onClickSave("notedit", detail);
    }


    return (
        <Container>
            <Banner className="content-center">
                <div className="icon-header-box vertical-center"><img alt="img" className="icon-header" src={IconComplete} /></div>
                <div className="label vertical-center">ขอบคุณ<br />ที่ร่วมตอบแบบสอบถามกับกกท.</div>
                <div className="icon-sat-box"><img alt="img" className="icon-sat" src={IconSAT} /></div>
            </Banner>
            <Body>
                {!haveHistory &&
                    <>
                        <div className="description">เพื่อการทำสถิติของ กกท. กรุณาบอกเราหน่อย</div>
                        <InputComponent
                            label={"ชื่อ"}
                            placeholder={"กรุณาระบุชื่อ"}
                            value={detail.firstname}
                            onInput={(e) => handleChange("firstname", e)}
                            styleContainer={{ marginBottom: "8px" }}
                        />
                        <InputComponent
                            label={"นามสกุล"}
                            placeholder={"กรุณาระบุนามสกุล"}
                            value={detail.lastname}
                            onInput={(e) => handleChange("lastname", e)}
                            styleContainer={{ marginBottom: "8px" }}
                        />
                        <InputComponent
                            label={"ข้อมูลการติดต่อ"}
                            placeholder={"กรุณาระบุหมายเลขโทรศัพท์"}
                            value={detail.mobile_number}
                            onInput={(e) => handleChange("mobile_number", e)}
                            isError={isInvalidValue.mobile_number}
                            labelError={"เบอร์โทรศัพไม่ถูกต้อง"}
                            styleContainer={{ marginBottom: "8px" }}
                        />
                        <DatePickerComponent
                            label={"วัน เดือน ปี เกิด"}
                            placeholder={"กรุณาเลือกวันเดือนปีเกิด"}
                            value={detail.birthdate}
                            onSelect={(e) => handleChange("birthdate", e)}
                            styleContainer={{ marginBottom: "8px" }}
                        />
                        <InputComponent
                            label={"ภูมิลำเนา"}
                            placeholder={"กรุณาระบุ"}
                            value={detail.province}
                            onInput={(e) => handleChange("province", e)}
                            styleContainer={{ marginBottom: "8px" }}
                        />
                    </>
                }
                {haveHistory ?
                    <ButtonComponent
                        label={"ยืนยัน"}
                        variant={"primary"}
                        onClick={handleClickCancel}
                    />
                    :
                    <div className="content-center button-footer">
                        <ButtonComponent
                            label={"ไว้ภายหลัง"}
                            variant={"secondary"}
                            onClick={handleClickCancel}
                        />
                        <ButtonComponent
                            label={"ยืนยันข้อมูล"}
                            variant={"primary"}
                            onClick={handleClickSave}
                        />
                    </div>
                }
            </Body>
        </Container>
    )
}

export default EvaluationFormProfile;